import {Component, Input} from '@angular/core';

export enum TooltipType {
	WARNING = 'warning',
	SUCCESS = 'success',
	ERROR = 'error',
	INFO = 'info'
}

export enum TooltipPosition {
	LEFT = 'left',
	RIGHT = 'right',
	ABOVE = 'above',
	BELOW = 'below'
}

export interface Tooltip {
	type: TooltipType;
	text: string;
	position: TooltipPosition;
	iconClass: string;
}

@Component({
	selector: 'amd-tooltip',
	templateUrl: './tooltip.component.html',
	styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {

	@Input() item: Tooltip;
	show: boolean;

	open(event: any): void {
		this.show = true;
		event.stopPropagation();
	}

	close(event: any): void {
		this.show = false;
		event.stopPropagation();
	}

	toggle(event: any): void {
		this.show = !this.show;
		event.stopPropagation();
	}

}
